module.exports = __webpack_public_path__ + "img/tick-delivered.c3d4d67f.svg";